export default __webpack_public_path__ + "static/2407-eb906cd27c4a84ca99d23a75c9d8bea5.jpg";